import React from 'react';

const AdminLayout = ({ children, title, description }) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Administración</h1>
          <p className="text-sm text-gray-600 mt-1">
            {description || 'Configura las opciones del establecimiento y gestiona el sistema'}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
